import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";

import { Input, Row, Card, Form, DatePicker, Col, Divider, Spin } from "antd";
import ApproveInterbankContract from "./ApproveInterbankContract";
import DisburseInterbankContract from "./DisburseInterbankContract";
import RejectInterBankContract from "./RejectInterBankContract";
import AmendnterbankContract from "./AmendInterBankContract";
import TerminateInterBankContract from "./TerminateInterBankContract";

const { TextArea } = Input;
const InterBankMainActionPage = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // console.log(state);
  }, []);

  const renderActions = () => {
    switch (state?.actionLabel?.toLowerCase()) {
      // case "modify application":
      //   return <ModifySavingsAccount userData={userData} />;
      case "approve deal":
        return <ApproveInterbankContract userData={userData} />;
      case "disburse deal":
        return <DisburseInterbankContract userData={userData} />;
      case "reject deal":
        return <RejectInterBankContract userData={userData} />;
      case "amend deal":
        return <AmendnterbankContract userData={userData} />;
      case "terminate deal":
        return <TerminateInterBankContract userData={userData} />;

      // case "close":
      //   return <CloseSavingsAcc userData={userData} />;

      default:
        return <>No {state.actionLabel} Component found contact dev</>;
    }
  };
  return <>{renderActions()}</>;
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
export default connect(mapStateToProps, null)(InterBankMainActionPage);
